<template>
  <div style="border: 1px solid #ccc" :style="{ height: props.height + 'px' }" class="flex flex-col">
    <Toolbar style="border-bottom: 1px solid #ccc" :editor="editorRef" :defaultConfig="toolbarConfig" :mode="mode" />
    <Editor class="flex-1" style="overflow-y: hidden" v-bind="$attrs" :defaultConfig="editorConfig" :mode="mode" @onCreated="handleCreated" />
  </div>
</template>

<script setup lang="ts">
import '@wangeditor/editor/dist/css/style.css' // 引入 css
import { onBeforeUnmount, shallowRef, onMounted, nextTick } from 'vue'
import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
import tool from '@/utils/tool'

const props = withDefaults(
  defineProps<{
    height?: number
  }>(),
  {
    height: 500
  }
)

const meta = import.meta.env

const editorRef = shallowRef()

const mode = 'simple'

const toolbarConfig = {}
type InsertFnType = (url: string, alt: string, href: string) => void
const editorConfig: Record<string, any> = {
  placeholder: '请输入内容...',
  pasteFilterStyle: false,

  MENU_CONF: {
    uploadImage: {
      server: meta.VITE_APP_PROXY_PREFIX + '/api/v1/sys/uploadImg',
      // form-data fieldName ，默认值 'wangeditor-uploaded-image'
      fieldName: 'img',

      // 单个文件的最大体积限制，默认为 2M
      maxFileSize: 5 * 1024 * 1024, // 1M

      // 最多可上传几个文件，默认为 100
      maxNumberOfFiles: 10,

      // 选择文件时的类型限制，默认为 ['image/*'] 。如不想限制，则设置为 []
      allowedFileTypes: ['image/*'],

      // 自定义上传参数，例如传递验证的 token 等。参数会被添加到 formData 中，一起上传到服务端。
      meta: {},

      // 将 meta 拼接到 url 参数中，默认 false
      metaWithUrl: false,

      // 自定义增加 http  header
      headers: {
        authorization: 'Bearer ' + tool.local.get('token')
      },

      // 跨域是否传递 cookie ，默认为 false
      withCredentials: true,

      // 超时时间，默认为 10 秒
      timeout: 5 * 1000, // 5 秒
      // 自定义插入图片
      customInsert(res: any, insertFn: InsertFnType) {
        // TS 语法
        // customInsert(res, insertFn) {                  // JS 语法
        // res 即服务端的返回结果

        // 从 res 中找到 url alt href ，然后插入图片
        console.log('res-----------上传成功 :>> ', res)
        insertFn(res.data.imgUrl, res.data.imgUrl, res.data.imgUrl)
      }
    }
  }
}

// 组件销毁时，也及时销毁编辑器
onBeforeUnmount(() => {
  const editor = editorRef.value
  if (editor == null) return
  editor.destroy()
})

const handleCreated = (editor) => {
  editorRef.value = editor // 记录 editor 实例，重要！
}
</script>

<style scoped></style>
